import { PortableText } from '@portabletext/react'
import { useState } from 'react'

import { type BasicSection } from '~/lib/sanity.queries'

import Button from './Button'
import CTA from './CTA'
import { FadeUpInView } from './FadeUpInView'
import { Column, Grid } from './Grid'
import PortableTextScrollAnimation from './TextAnimation'

export default function BasicSection({
  content,
  titleSize = 'h2',
  start,
  end,
}: {
  content: BasicSection
  titleSize?: 'h2' | 'h3'
  start?: string
  end?: string
}) {
  const [ctaIsHovered, setCtaIsHovered] = useState(false)

  return (
    <Grid className="text-center my-32 md:my-64 z-10">
      <Column className="col-span-12 relative">
        <div className="bg-gradient-blur opacity-20"></div>
        <div className="flex flex-col items-center justify-center relative">
          {content?.title && (
            <div className={`${titleSize} text-center text-pretty pb-2`}>
              <PortableTextScrollAnimation
                value={content.title}
                start={start}
                end={end}
              />
            </div>
          )}
          {content?.body && (
            <div className="mt-6 body-large text-grey text-pretty md:px-0 max-w-[330px] md:max-w-4xl mx-auto">
              <PortableTextScrollAnimation
                value={content.body}
                start={start}
                end={end}
              />
            </div>
          )}
          {(content?.primaryCTA || content?.secondaryCTA) && (
            <div
              className={`flex flex-row items-center justify-center gap-8 mt-9 flex-wrap transform transition-transform duration-500 ${ctaIsHovered ? 'md:translate-x-6' : ''}`}
            >
              {content?.primaryCTA && (
                <Button
                  href={content.primaryCTA.url}
                  asLink
                  pin="right"
                  onMouseEnter={() =>
                    content?.secondaryCTA && setCtaIsHovered(true)
                  }
                  onMouseLeave={() =>
                    content?.secondaryCTA && setCtaIsHovered(false)
                  }
                >
                  {content.primaryCTA.text}
                </Button>
              )}
              {content?.secondaryCTA && (
                <CTA href={content.secondaryCTA.url} asLink>
                  {content.secondaryCTA.text}
                </CTA>
              )}
            </div>
          )}
        </div>
      </Column>
    </Grid>
  )
}
